import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/pick/activity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1214854546/src/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameProvider"] */ "/codebuild/output/src1214854546/src/client/src/utils/providers/game.tsx");
